import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { apiClient } from '@services/api'

interface Tile { id: string; icon: string; title: string; desc: string; source: string }

const FALLBACK: Tile[] = [
  { id: 'store-performance', icon: '🏪', title: 'Store Performance', desc: 'Prev month vs MTD sales, gross profit, outstanding — per shop', source: 'store_performance_summary' },
  { id: 'supplier-performance', icon: '🚚', title: 'Supplier Performance', desc: 'Prev month vs MTD purchases, paid, payable — per supplier', source: 'supplier_performance_summary' },
  { id: 'sales-register', icon: '🧾', title: 'Sales Register', desc: 'Every invoice in a date range, GST breakup, payment status', source: 'invoices' },
  { id: 'purchase-register', icon: '📦', title: 'Purchase Register', desc: 'Every purchase bill in a date range, GST breakup, payment status', source: 'purchase_bills' },
  { id: 'gst-summary', icon: '📊', title: 'GST Summary', desc: 'Output GST vs Input GST for a filing period', source: 'invoices, purchase_bills' },
  { id: 'stock-valuation', icon: '💰', title: 'Stock Valuation', desc: 'Stock value by segment, by product, as of today', source: 'daily_stock_value_summary' },
  { id: 'credit-aging', icon: '⏰', title: 'Credit Aging', desc: "Store-wise overdue buckets — what's owed to you", source: 'credit_ledger' },
  { id: 'payable-aging', icon: '⏳', title: 'Payable Aging', desc: 'Supplier-wise overdue buckets — what you owe', source: 'supplier_ledger' },
  { id: 'repacking-yield', icon: '⚖️', title: 'Repacking Yield & Loss', desc: 'Predicted vs actual consumption, validated loss', source: 'daily_repacking_summary' },
  { id: 'gross-profit-trend', icon: '📈', title: 'Gross Profit Trend', desc: 'Daily gross profit with a monthly roll-up', source: 'daily_gross_profit_summary' },
  { id: 'returns-credit-notes', icon: '↩️', title: 'Returns & Credit Notes', desc: 'Every return, reason, value, linked credit note', source: 'sales_returns, credit_notes' },
  { id: 'salesman-performance', icon: '🧍', title: 'Salesman Performance', desc: 'Sales, collections, stores covered per salesman', source: 'invoices, collections' },
]

export function Reports() {
  const navigate = useNavigate()
  const { data } = useQuery({ queryKey: ['report-tiles'], queryFn: () => apiClient.get<any>('/reports') })
  const tiles: Tile[] = data?.data?.items?.length ? data.data.items : FALLBACK
  return (
    <div>
      <div className="hdr">
        <h1>Reports</h1>
        <p>Click a report to open it — all support date-range filtering and export.</p>
      </div>
      <div className="report-grid">
        {tiles.map((t) => (
          <div key={t.id} className="report-tile" role="button" tabIndex={0} onClick={() => navigate(`/dashboard/reports/${t.id}`)} onKeyDown={(e) => { if (e.key === 'Enter') navigate(`/dashboard/reports/${t.id}`) }}>
            <div className="ricon">{t.icon}</div>
            <h3>{t.title}</h3>
            <p>{t.desc}</p>
            <div className="rsrc">{t.source}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
